// jshint ignore: start

export default {
  email_suggestion: {
    prefix: 'Você quis dizer',
    suffix: '?',
    accept_label: 'Alterar o e-mail para {{email}}',
  },
  auth_modal: {
    aria_label: {
      login: 'Entrar na CGTrader',
      signup: 'Cadastrar-se na CGTrader',
    },
    header: {
      login_title: 'Bem-vindo de volta',
      signup_title: 'Crie sua conta',
      login_subtitle: 'Entre para continuar criando, projetando e baixando.',
    },
    social_divider: 'ou com e-mail',
    email_label: 'E-mail',
    email_placeholder: 'john@email.com',
    email_aria_label: 'Endereço de e-mail',
    opt_in_label: 'Receba novidades de produtos, notícias da comunidade e ofertas.',
    submit_button: 'Continuar com e-mail',
    switch: {
      already_member: 'Já é membro? ',
      log_in: 'Entrar',
      new_here: 'Novo por aqui? ',
      create_account: 'Criar uma conta',
    },
    terms: {
      prefix: 'Ao continuar, concordo com os ',
      terms_link: 'Termos e Condições Gerais',
      middle: ' e a ',
      privacy_link: 'Política de Privacidade.',
      suffix: '',
    },
    code: {
      title: 'Verifique sua caixa de entrada',
      subtitle_prefix: 'Enviamos um código de 6 dígitos para ',
      subtitle_suffix: '',
      email_fallback: 'seu e-mail',
      digit_aria_label: 'Dígito {{number}}',
      error: 'Código de acesso inválido. Por favor, tente novamente.',
      resend_prompt: 'Não recebeu? ',
      resend_link: 'Reenviar código',
      resend_countdown: 'Reenviar código em {{time}}',
      change_email_link: 'Alterar e-mail',
    },
    success: {
      login_title: 'Bem-vindo de volta',
      signup_title: 'Você está dentro',
      signed_in_prefix: 'Conectado como ',
      signed_in_suffix: '',
      signup_subtitle: 'Conta criada. Vamos encontrar seu próximo modelo.',
    },
    password: {
      link: 'Entrar com senha',
      email_label: 'E-mail ou nome de usuário',
      title: 'Entrar com senha',
      subtitle: 'Digite seu e-mail e senha para continuar.',
      password_label: 'Senha',
      forgot_password: 'Esqueceu a senha?',
      submit_button: 'Entrar',
      back: 'Voltar',
      show_password: 'Mostrar senha',
      hide_password: 'Ocultar senha',
      error_generic: 'Algo deu errado. Por favor, tente novamente mais tarde.',
      required_notice: 'Digite também sua senha para concluir a 2FA.',
      two_fa_code_label: 'Código de verificação',
    },
  },
  login: {
    generic_auth_error: 'Algo deu errado. Por favor, tente novamente mais tarde.',
  },
  itemPage: {
    licenseDropdown: {
      aiContactNote: {
        question: 'Precisa de uma licença compatível com IA?',
        linkText: 'Entre em contato com nossa equipe de vendas para opções de licenciamento de dados Enterprise.',
      },
    },
    units: {
      mm: 'Milímetros',
      cm: 'Centímetros',
      in: 'Pulgadas',
      m: 'Metros',
    },
    supportForm: {
      messageSent: 'A mensagem foi enviada com sucesso',
    },
  },
  listingPage: {
    pagination: {
      label: 'Paginação',
      firstPage: 'Ir para a primeira página',
      previousPage: 'Ir para a página anterior',
      nextPage: 'Ir para a próxima página',
      lastPage: 'Ir para a última página',
      page: 'Página {{number}}',
    },
    filters: {
      allFilters: 'TODOS OS FILTROS',
      resetFilters: 'Limpar',
      lastUsed: 'Último',
      fileFormat: 'Formatos de arquivo',
      searchPlaceholder: 'Digite para pesquisar',
      price: {
        freeOnly: 'Apenas gratuitos',
        onSale: 'Em promoção (até {{percentage}}% de desconto)',
      },
      customPriceRange: 'Faixa de preço personalizada',
      quickSelections: 'Seleções rápidas',
      subscriptionTier: {
        label: 'Assinaturas',
        all: 'Todos',
      },
      pricePlaceholder: 'Preço',
      polyCountRange: 'Faixa de polígonos personalizada',
      cardSize: 'Tamanho do cartão',
      cardVisibility: 'Configurações de visibilidade',
      visibility: {
        format: 'Formato',
        price: 'Preço',
        cgtStandard: 'Padrão CGT',
        type: 'Tipo',
        title: 'Título',
        quickActionsOnHover: 'Ações rápidas ao passar o mouse',
        suggestions: 'Sugestões',
      },
      items: 'itens',
      perPage: 'Por página:',
      wishListOnly: 'Mostrar apenas lista de desejos',
      hideOwnedModels: 'Ocultar modelos próprios',
      ownedModels: 'Apenas modelos comprados',
      sortBy: {
        default: 'Padrão',
        label: 'Ordenar',
      },
      remaining: {
        label: 'Filtros',
      },
      showMoreButtonText: 'Mostrar mais',
    },
    suggestedSearch: {
      showingResultsFor: 'Mostrando resultados para',
      ifYouMeant: 'Se você quis dizer',
      tryThatSearchInstead: 'tente essa pesquisa',
    },
    gallery: {
      formats: 'Formatos',
      geometry: 'Geometria',
      type: 'Tipo',
      details: 'Detalhes',
      unknown: 'Desconhecido',
      polygons: '{{value}} polígonos',
      vertices: '{{value}} vértices',
      previewing: 'PRÉ-VISUALIZAÇÃO',
      types: {
        print_ready: 'Impressão 3D',
        pbr: 'PBR',
        animated: 'Animado',
        rigged: 'Com rig',
        low_poly: 'Low-poly',
      },
      attributes: {
        textures: 'Texturas',
        materials: 'Materiais',
        uvw_mapping: 'Mapeamento UV',
        plugins_used: 'Plugins utilizados',
      },
    },
    actions: {
      preview: 'Pré-visualizar',
      see_similar_models: 'Ver modelos semelhantes',
      add_to_cart: 'Adicionar ao carrinho',
      remove_from_cart: 'Remover do carrinho',
      add_to_wishlist: 'Adicionar à lista de desejos',
      remove_from_wishlist: 'Remover da lista de desejos',
      purchased: 'Comprado',
      open: 'Abrir',
    },
    download: {
      tooltip: 'Baixar',
      header: 'Baixar arquivos',
      loading: 'Carregando arquivos...',
      empty: 'Nenhum arquivo disponível para download.',
    },
    upsellBlock: {
      label: 'oferta especial',
      heading: 'Baixe mais modelos por menos',
      bodyModels: '25 modelos por mês',
      bodyMiddle: ', a partir de ',
      bodyPrice: 'US$ 9,99',
      cta: 'Assinar',
    },
    footerBanners: {
      title: 'Não consegue encontrar o que procura?',
      hire3dFreelancerBanner: {
        title: 'Contratar freelancer 3D',
        description: 'Você terá a oportunidade de colaborar diretamente com designers 3D experientes em uma ampla gama de projetos personalizados, incluindo impressão 3D e animação.',
        description2: 'Simplesmente envie uma descrição do projeto e receba orçamentos de diferentes designers, permitindo que você selecione o mais adequado às suas necessidades.',
        learnMoreButtonText: 'Saiba mais',
        learnMoreButtonUrl: '/pt/3d-modeling-jobs',
        postAProjectButtonText: 'Publicar um projeto',
      },
      searchSubscription: {
        title: 'Assinar esta busca',
        description: 'Vamos lembrar as configurações da sua busca e avisar quando surgir algo novo.',
        subscribe: 'Assinar',
        subscribing: 'Assinando...',
        inputPlaceholder: 'Descreva sua busca com mais detalhes para nos ajudar a melhorar significativamente a biblioteca de modelos 3D.',
      },
    },
  },
  browser: {
    filters: {
      cgt_standard_only: 'Padrão CGT',
      cgt_standard_tooltip_title: 'Padrão CGT - pronto para importar, sem necessidade de limpeza.',
      cgt_standard_tooltip_body: 'Conferido automaticamente em geometria, UVs, texturização, configuração de cena e nomenclatura - funciona no Blender, Maya, Unreal Engine, Unity e outras ferramentas principais. Verificado automaticamente - não declarado pelo vendedor.',
    },
  },
  printModelPage: {
    sectionTitle: 'IMPRESSÃO 3D',
    heroTitle: 'Explorar modelos para impressão 3D',
    sectionDescription: 'Modelos, arquivos e assets 3D de alta qualidade prontos para uso doméstico ou profissional com impressoras 3D FDM, SLA ou SLS.',
    placeholderText: 'Pesquisar em mais de 800.000 modelos 3D para impressão',
    allCategories: 'Navegar por todos os modelos',
    categorySectionTitle: "Arquivos 3D para impressão para cada ideia",
    categorySectionDescription: "Navegue por arquivos 3D de alta qualidade projetados para impressão 3D FDM, SLA ou resina. Encontre o modelo 3D impresso certo para qualquer projeto.",
    categorySectionButtonText: "Navegar por todos os arquivos",
    categorySectionBadgeText: "CATEGORIAS",
    budgetSectionTitle: "Descubra modelos que cabem no seu orçamento",
    budgetSectionDescription: "Descubra modelos econômicos sem comprometer a qualidade",
    BrowseAllText: 'Navegar por todos'
  },
  projects: {
    newestFirst: 'Newest first',
    highestBudget: 'Highest budget',
    fewestApplicants: 'Fewest applicants',
    modelingJob: '3d modeling job',
    myProjects: 'My 3D Projects',
    projects: '3D Projects',
    reviewProjectApplication: 'Review 3D Project application',
    startAProject: 'Start a Project',
    editProject: 'Edit Project',
    reviewProject: 'Review Project',
    applyToProject: 'Apply to 3D Project',
    editProjectApplication: 'Edit 3D Project application',
    learnMoreHowItWorks: 'Learn more how it works',
    projectsDashboard: 'Projects dashboard',
    cgtraderModelingJob: 'CGTrader 3D Modeling Jobs',
    software: '3D Software',
    skills: '3D Skills',
    searchPlaceholder: 'Search'
  },
  subscription_management: {
    empty_state: {
      message: 'Você não tem uma assinatura ativa',
      view_essentials: 'Ver Essentials',
      view_essentials_premium: 'Ver planos Essentials e Premium',
    },
    active: {
      plan_name: {
        essentials: 'CGTrader Essentials',
        premium: 'CGTrader Premium',
      },
      badge_cancelled: 'Cancelada',
      cancel_button: 'Cancelar assinatura',
      renew_button: 'Renovar assinatura',
      reactivate_button: 'Reativar assinatura',
      annual_plan: 'Plano Anual',
      monthly_plan: 'Plano Mensal',
      renewal_message_prefix: 'A sua assinatura será renovada automaticamente em ',
      renewal_message_suffix: '',
      monthly_renewal_message: 'A sua assinatura é renovada mensalmente',
      switch_plan: 'Mudar de plano',
      billing: {
        billing_cycle: 'Ciclo de cobrança',
        next_billing_date: 'Próxima data de cobrança',
        no_renewal: 'Sem cobranças adicionais',
        billing_suspended: 'Cobrança suspensa',
        auto_resume: '{{date}} (retomada automática)',
        pauses_on: 'Pausa em {{date}}',
        price: 'Preço',
        payment_method: 'Método de pagamento',
        update: 'Atualizar',
      },
      usage: {
        progress_label: '{{used}} de {{limit}} modelos baixados',
        paused_tooltip: 'Você não pode baixar modelos enquanto sua assinatura está pausada. Retome para baixar novamente.',
      },
      cancel_info: {
        title: 'O que acontece se eu cancelar?',
        keep_access: 'Você manterá o acesso até o final do período já pago',
        no_downloads: 'Após o cancelamento, você não poderá baixar novos modelos',
        keep_license: 'Os modelos que você já baixou permanecem licenciados para os projetos concluídos enquanto a assinatura estava ativa',
        cancellation_fee: 'A taxa de cancelamento não se aplica se você cancelar nos primeiros 45 dias. Após esse período, será cobrada uma taxa de cancelamento de 50% do saldo restante da sua obrigação contratual.',
        cancellation_fee_new_yearly: 'Cancelar sua assinatura resultará em uma taxa de cancelamento antecipado de 50% do saldo restante do contrato. Você manterá o acesso pelo período coberto pela taxa.',
      },
    },
    paused: {
      badge_paused: 'Pausada',
      badge_scheduled: 'Pausa agendada',
      resume_button: 'Retomar assinatura',
      cancel_scheduled_pause_button: 'Cancelar pausa agendada',
    },
    pause_offer: {
      hero_amount: '$0',
      hero_caption: 'cobrado durante a pausa',
      title: 'Faça uma pausa — não cancele',
      description: 'A pausa começa após o término do seu período atual. Você pode retomar a assinatura quando quiser, ou ela será retomada automaticamente após 1 mês.',
      benefits: {
        no_extra_charges: 'Sem cobranças adicionais',
        downloads_licensed: 'Downloads continuam licenciados',
        resume_anytime: 'Retome quando quiser',
      },
      pause_button: 'Pausar minha assinatura',
      continue_to_cancel: 'Continuar para o cancelamento',
    },
    pause_confirmation: {
      header: 'Pausa agendada',
      title: 'Sua assinatura será pausada',
      description: 'Você terminará o período já pago e a assinatura será pausada em {{date}}. Não haverá cobrança durante a pausa. Retome quando quiser — ou ela será retomada automaticamente após 1 mês.',
      description_no_date: 'Você terminará o período já pago e então sua assinatura será pausada. Não haverá cobrança durante a pausa. Retome quando quiser — ou ela será retomada automaticamente após 1 mês.',
      done_button: 'Concluído',
    },
    pause: {
      errors: {
        generic: 'Algo deu errado. Atualize a página e tente novamente.',
        subscription_not_found: 'Não encontramos esta assinatura. Atualize a página.',
        subscription_cannot_be_paused: 'Esta assinatura não pode ser pausada no momento. Atualize a página.',
        subscription_pause_already_scheduled: 'Já existe uma pausa agendada para esta assinatura. Atualize a página.',
        subscription_billing_period_unavailable: 'Não foi possível agendar a pausa. Tente novamente mais tarde ou entre em contato com o suporte.',
        subscription_pause_start_must_be_future: 'Sua renovação está sendo processada. Tente novamente quando terminar.',
        user_pause_allowance_exhausted: 'Você já usou o tempo máximo de pausa para esta assinatura.',
        subscription_cannot_be_resumed: 'Esta assinatura não pode ser retomada. Atualize a página.',
        solidgate_request_failed: 'Ocorreu um erro com nosso provedor de pagamentos. Atualize a página e tente novamente.',
      },
    },
    billing_cycle: {
      yearly: 'Anual',
      monthly: 'Mensal',
    },
    switch_plan_section: {
      price_unit: '/mês',
      tags: {
        yearly: 'ECONOMIZE 60%',
        monthly: 'CANCELE QUANDO QUISER',
      },
    },
    switch_plan_modal: {
      title: 'Mudar de plano',
      cancel: 'Cancelar',
      current_plan: 'Plano atual',
      submit: {
        to_yearly: 'Mudar para o Plano Anual',
        to_monthly: 'Mudar para o Plano Mensal',
      },
      notice: {
        yearly_to_monthly: 'O seu plano mudará para Mensal no final do seu compromisso anual atual em {{date}}. Nenhuma ação é necessária até lá.',
        monthly_to_yearly: 'O seu plano mudará para Anual imediatamente. Um novo compromisso de 12 meses começa hoje. Taxas de cancelamento antecipado aplicam-se após a primeira cobrança.',
      },
      plan: {
        yearly: {
          name: 'Plano Anual',
          subtitle: 'cobrado mensalmente',
        },
        monthly: {
          name: 'Plano Mensal',
          subtitle: 'sem compromisso',
        },
      },
      toast: {
        success: 'A sua mudança de plano foi agendada.',
        error: 'Não foi possível agendar a sua mudança de plano. Por favor, tente novamente.',
      },
      preview_toast_error: 'Não foi possível carregar os detalhes do plano. Por favor, tente novamente.',
    },
    scheduled_switch_banner: {
      title: 'Mudança de plano agendada',
      description_prefix: 'Você mudará para o',
      description_on: 'em',
      description_suffix: '. Você mantém seus benefícios anuais e a tarifa de {{price}} até lá.',
      cancel_button: 'Cancelar mudança agendada',
      cancel_success: 'A mudança de plano agendada foi cancelada.',
      cancel_error: 'Não foi possível cancelar a mudança de plano agendada. Por favor, tente novamente.',
    },
    cancel_modal: {
      title: 'Cancelar assinatura',
      reason_label: 'Por que deseja cancelar?',
      reason_placeholder: 'Selecione um motivo...',
      submit_button: 'Cancelar assinatura',
      reasons: {
        no_longer_need: 'Não preciso mais de modelos 3D no momento',
        short_term_project: 'Precisei apenas para um projeto de curto prazo',
        not_enough_models: 'Não encontrei modelos relevantes suficientes',
        not_worth_price: 'A assinatura não valia o preço',
        not_used_enough: 'Não usei o suficiente',
        prefer_individual: 'Prefiro comprar modelos individualmente',
        other: 'Outro',
      },
      other_label: 'Por favor, especifique',
      other_placeholder: 'Conte-nos mais...',
      banner_description: 'Seu acesso permanecerá ativo até {{date}}. Você não será cobrado novamente após esta data.',
      loading_fee: 'Carregando detalhes do cancelamento...',
      fee_error: 'Não foi possível carregar os detalhes da taxa de cancelamento. Por favor, feche e tente novamente.',
      fee_title: 'Taxa de cancelamento: {{fee}}',
      fee_description: 'Seu acesso permanecerá ativo até {{date}}. Uma taxa de cancelamento será cobrada no seu método de pagamento.',
      no_fee_description: 'Seu acesso permanecerá ativo até {{date}}. Não será cobrada taxa de cancelamento.',
      fee_title_header: 'Confirmar cancelamento antecipado',
      fee_warning_banner: 'O cancelamento implicará uma <strong>taxa de 50 %</strong>.',
      consequences_title: 'Antes de ir — veja o que acontece se você cancelar',
      consequences: {
        keep_access: 'Você manterá o acesso até o final do período já pago.',
        no_downloads: 'Após o cancelamento, você não poderá baixar novos modelos.',
        keep_license: 'Os modelos que você já baixou permanecem licenciados para os projetos concluídos enquanto a assinatura estava ativa.',
        fee_notice: 'A taxa de cancelamento não se aplica se você cancelar nos primeiros 45 dias. Depois disso, será cobrado 50% do saldo restante da sua obrigação contratual.',
        fee_notice_new_yearly: 'Cancelar sua assinatura resultará em uma taxa de cancelamento antecipado de 50% do saldo restante do contrato. Você manterá o acesso pelo período coberto pela taxa.',
      },
      remaining_months: 'Meses restantes',
      monthly_rate: 'Taxa mensal',
      total_remaining: 'Total restante',
      cancellation_fee_percent: 'Taxa de cancelamento de 50 %',
      calculated_active_period: 'Seu período ativo calculado',
      contract_commitment_value: 'Valor do compromisso contratual:',
      cancellation_fee_summary: 'Taxa de cancelamento (50 %):',
      acknowledge_checkbox: 'Eu entendo a taxa e desejo prosseguir com o cancelamento',
      keep_subscription_button: 'Manter assinatura',
      back_button: 'Voltar',
      continue_button: 'Continuar para o cancelamento',
      success: 'Sua assinatura foi cancelada com sucesso.',
      error: 'Falha ao cancelar a assinatura. Por favor, tente novamente.',
      confirmation: {
        header: 'Assinatura cancelada',
        title: 'Sua assinatura foi cancelada',
        body_no_fee: 'Você manterá o acesso até {{date}}. Depois disso, não poderá baixar novos modelos, mas tudo o que você já baixou permanece licenciado. Nenhuma taxa de cancelamento foi cobrada.',
        body_no_fee_no_date: 'Quando o seu período atual terminar, você não poderá baixar novos modelos, mas tudo o que você já baixou permanece licenciado. Nenhuma taxa de cancelamento foi cobrada.',
        body_fee: 'Você manterá o acesso até {{date}}. Uma taxa de cancelamento antecipado de 50% no valor de {{fee}} foi cobrada. Os modelos que você já baixou permanecem licenciados.',
        done_button: 'Concluído',
      },
    },
    retry_payment: {
      button: 'Tentar pagamento novamente',
      button_loading: 'Tentando novamente...',
      helper_text: 'Já resolveu o problema com seu banco? Tente a cobrança novamente sem alterar o cartão.',
      processing: {
        title: 'Nova tentativa de pagamento em andamento',
        description: 'Recebemos sua solicitação. O pagamento pode levar alguns minutos para ser processado - enviaremos um e-mail assim que for concluído.',
      },
      error: {
        default: 'O pagamento falhou novamente. Atualize o método de pagamento ou tente mais tarde.',
      },
    },
    status_banners: {
      pause_scheduled: {
        title: 'Sua assinatura será pausada em {{date}}.',
        description: 'O acesso permanece ativo até o final do ciclo atual. Não haverá cobrança durante a pausa, e você pode retomar a qualquer momento.',
      },
      paused: {
        title: 'Sua assinatura está pausada.',
        description: 'Não haverá cobrança durante a pausa. Retome a qualquer momento nesta página.',
        description_operational: 'Não haverá cobrança durante a pausa.',
      },
      resume_requested: {
        title: 'Retomada solicitada',
        description: 'Estamos retomando sua assinatura — isso pode levar um momento. Atualize a página para ver o status atualizado.',
      },
      redemption: {
        title: 'Problema de pagamento \u2014 atualize o método de pagamento',
        description: 'Sua última tentativa de pagamento falhou. Tentaremos novamente automaticamente ou você pode atualizar o método de pagamento para tentar agora.',
      },
      suspended: {
        title: 'Sua assinatura foi suspensa',
        description: 'Suspensa em {{date}}. Por favor',
        description_no_date: 'Por favor',
        contact_link: 'entre em contato',
        description_suffix: 'com o suporte para assistência.',
      },
    },
    payment_history: {
      status: {
        failed: 'Falhou',
      },
    },
  },
  subscription_item_page: {
    subscribe_cta: 'Assine e economize',
    upgrade_cta: 'Fazer upgrade do plano',
  },
  subscription_upgrade: {
    explainer: {
      prefix: 'Fazendo upgrade a partir do Essentials. Você usou',
      used_of_limit: '{{used}} de {{limit}}',
      middle: 'downloads neste período, então creditamos os',
      unused: '{{unused}} não usados',
      suffix: 'na cobrança de hoje.'
    },
    payment_method: {
      title: 'Forma de pagamento',
      subtitle: 'Usaremos o cartão salvo na sua conta — não é preciso inseri-lo novamente.',
      saved_badge: 'Salvo',
      use_different: 'Usar outra forma de pagamento'
    },
    order_summary: {
      title: 'Resumo do pedido',
      plan_name: 'Assinatura CGTrader Premium',
      plan_cadence: 'plano anual, cobrado mensalmente',
      billing_period: '1 ano por',
      premium_price: 'Subtotal Premium',
      credit_label: 'Crédito Essentials',
      credit_basis: '{{unused}} de {{limit}} downloads não usados',
      vat_included: 'IVA (incluído)',
      vat_tooltip: 'O Imposto sobre Valor Agregado (IVA), também conhecido como imposto sobre vendas ou imposto sobre bens e serviços (GST), é um imposto aplicado no ponto de venda ao comprador final e pago ao governo do país do comprador.',
      amount_due_today: 'Valor a pagar hoje',
      cta: 'Pague {{amount}} e faça upgrade',
      next_billing_note: '*Próxima cobrança de {{price}}/mês',
      legal_agreement_prefix: 'Ao continuar, concordo com os',
      legal_agreement_terms: 'Termos e Condições Gerais',
      legal_agreement_privacy: 'Política de Privacidade',
      legal_agreement_connector: 'e a',
    }
  },
  subscription_checkout: {
    title: 'Escolha uma forma de pagamento',
    subtitle: 'Pague com segurança usando Apple Pay, Google Pay, PayPal ou cartão de crédito.',
    divider_text: 'Ou',
    credit_card_button: 'Pagar com cartão de crédito / débito',
    terms: {
      title: 'Você está se inscrevendo em uma assinatura anual do serviço CGTrader.',
      body_start: 'Você concorda em ser cobrado {{price}} por mês até o final do contrato ou cancelamento da assinatura. Os pagamentos serão cobrados pelo método de pagamento que você selecionou. Para cancelar, vá para Configurações da Conta → Gerenciamento da Assinatura ou consulte nossa <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" class="cgt-legacy-link">Política de Cancelamento</a>. ',
      body_end: 'Observe que o plano anual tem uma taxa de cancelamento antecipado.',
      annual: {
        title: 'Termos da assinatura anual (cobrança mensal)',
        body: 'Você está se inscrevendo em uma assinatura anual da CGTrader. Você concorda em ser cobrado {{price}}/mês mais impostos aplicáveis até o final do contrato ou cancelamento. Você pode cancelar quando quiser. Se cancelar nos primeiros 45 dias, não há taxa de cancelamento antecipado. Após esse período, uma taxa pode ser aplicada. Para cancelar, vá para Configurações da Conta → Gerenciamento da Assinatura ou consulte nossa <a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" rel="noreferrer" class="cgt-legacy-link">Política de Cancelamento</a>.',
      },
      monthly: {
        title: 'Termos da assinatura mensal',
        body: 'Você está se inscrevendo em uma assinatura mensal da CGTrader. Você concorda em ser cobrado {{price}}/mês. Cancele a qualquer momento em Configurações da Conta → Gerenciamento da Assinatura sem taxas.',
      },
    },
    plan_selector: {
      section_title: 'Escolha o plano',
      names: {
        yearly: 'Plano anual',
        monthly:        'Plano mensal',
      },
      subtitles: {
        billed_monthly: 'cobrança mensal',
        no_commitment: 'sem compromisso',
      },
      badges: {
        save_60:        'Economize 60%',
        cancel_anytime: 'Cancele quando quiser',
      },
      select_aria: 'Selecione o {{name}}',
    },
    update_title: 'Atualizar método de pagamento',
    update_subtitle: 'Atualize seus dados de pagamento com segurança.',
    update_credit_card_button: 'Cartão de crédito / débito',
    update_save_button: 'Salvar',
    update_cancel_button: 'Cancelar',
    order_summary: {
      title: 'Resumo do pedido',
      item_context: {
        sub_label: 'Disponível para download após a assinatura',
      },
      billing_period: '1 ano por',
      price_unit: '/mês',
      subtotal: 'Subtotal',
      vat_included: 'IVA',
      vat_tooltip: 'O Imposto sobre Valor Agregado (IVA), também conhecido como imposto sobre vendas ou imposto sobre bens e serviços (GST), é um imposto aplicado no ponto de venda ao comprador final e pago ao governo do país do comprador.',
      amount_due_today: 'Total do pedido',
      pay_button: 'Assinar por {{amount}}',
      pay_button_upgrade: 'Pague {{amount}} e faça upgrade',
      premium_renewal_note: 'O Premium é desbloqueado imediatamente – depois {{price}}/mês a partir de {{date}}',
      legal_agreement_prefix: 'Ao continuar, concordo com os',
      legal_agreement_terms: 'Termos e Condições Gerais',
      legal_agreement_privacy: 'Política de Privacidade',
      legal_agreement_connector: 'e a',
      plans: {
        yearly: {
          name:           'Assinatura CGTrader Essentials — plano anual, cobrado mensalmente',
          billing_period: '1 ano por',
          price_unit:     '/mês',
          features: {
            first:  '25 recursos / mês — baixe modelos ou gere com IA',
            second: 'Acesso instantâneo a mais de {{modelCount}} modelos 3D essenciais',
            third:  'Livre de royalties, sem IA',
          },
        },
        monthly: {
          name:           'CGTrader Essentials — plano mensal',
          billing_period: '',
          price_unit:     '/mês',
          features: {
            first:  '25 recursos / mês — baixe modelos ou gere com IA',
            second: 'Acesso instantâneo a mais de {{modelCount}} modelos 3D essenciais',
            third:  'Livre de royalties, sem IA',
          },
        },
      },
    },
    company: {
      toggle_label: 'Purchase as a company',
      info_banner: 'Make sure you filled and applied company details.',
      company_name: 'Company name',
      company_code: 'Company code',
      vatin: 'Company tax number',
      vatin_tooltip: 'If your company is registered for VAT/GST/Sales or equivalent tax, please make sure to enter your tax number for validation (in some cases you might be eligible for 0% tax rate).',
      country: 'Country',
      state: 'State / Province',
      zip_code: 'Zip code',
      city: 'City',
      street_address: 'Street address',
      apply_button: 'Apply',
      applying: 'Applying...',
      field_required: 'Este campo é obrigatório',
    },
    payment_success_processing: 'Processando o pagamento. Por favor aguarde…',
    payment_retry_button: 'Tentar novamente',
    payment_success_toast: 'Os dados de pagamento foram salvos com sucesso.',
    payment_error_toast: 'Falha no pagamento. Tente novamente.',
    email_step: {
      title: 'Insira seu e-mail',
      subtitle: 'para continuar com a assinatura',
      email_label: 'Endereço de e-mail',
      email_placeholder: 'john@email.com',
      email_required: 'O e-mail é obrigatório',
      email_invalid: 'Insira um endereço de e-mail válido',
      helper_text: 'Será usado apenas para enviar informações transacionais.',
      continue_button: 'Continuar',
      login_link_prefix: 'Já tem uma conta?',
      login_link: 'Entrar',
      divider: 'ou',
    },
    captcha_step: {
      title: 'Verificação rápida de segurança',
      subtitle: 'Conclua a verificação abaixo para continuar para o pagamento.',
      continue_button: 'Continuar',
      incomplete: 'Conclua o captcha para continuar.',
      failed: 'A verificação do captcha falhou. Tente novamente.',
    },
    login_step: {
      info_title: 'Parece que você já tem uma conta',
      info_subtitle: 'Entre para continuar',
      title: 'Bem-vindo de volta',
      subtitle: 'Entre para completar sua assinatura',
      email_label: 'E-mail',
      password_label: 'Senha',
      login_button: 'Entrar e continuar',
      forgot_password: 'Esqueceu a senha?',
      hide_password: 'Ocultar senha',
      show_password: 'Mostrar senha',
    },
    guest_banner: {
      paying_as: 'Pagando como',
      not_you: 'Não é você?',
    },
    create_account: {
      notice_title: 'Payment successful - you are subscribed!',
      notice_body: 'Your {{plan}} subscription is now active. A confirmation has been sent to',
      notice_body_no_plan: 'Your subscription is now active. A confirmation has been sent to',
      title: 'One last step - create your account',
      subtitle: 'Set a password to log in, download your model, and manage your subscription.',
      email_label: 'Email',
      submit_button: 'Register and start downloading',
    },
  },
  my_subscriptions: {
    profile_header: {
      title: 'Definições de assinatura',
      description: 'Gerir a sua participação no programa Essentials.',
      learn_more: 'Saiba mais',
    },
    status_card: {
      title: 'CGTrader Essentials',
      badge_participating: 'Participando',
      badge_not_participating: 'Não participando',
      description: 'O programa de assinatura Essentials permite que os utilizadores acedam a uma biblioteca curada de modelos por uma taxa mensal.',
      participation_label: 'Participação:',
      participation_text: 'Todos os modelos elegíveis serão incluídos. Os modelos não podem ser selecionados individualmente.',
      revenue_share_label: 'Partilha de receitas:',
      revenue_share_text: 'Os ganhos são calculados com base na sua quota de downloads totais de assinatura do pool de receitas mensal.',
      manage_label: 'Gerir participação a qualquer momento:',
      manage_text: 'As alterações entram em vigor pouco após atualizar as suas definições.',
      join_title: 'CGTrader Essentials está incluído no programa Maximize os seus Ganhos.',
      join_description: 'Obtenha acesso a rendimentos de assinatura, partilha de receitas e oportunidades empresariais personalizadas.',
      join_button: 'Aderir ao programa Maximizar os meus ganhos',
    },
    tabs: {
      eligible_models: 'Modelos elegíveis',
      earnings: 'Rendimentos',
    },
    eligible_models: {
      description_line1: 'Veja todos os seus modelos elegíveis para gerar receitas de assinatura.',
      description_line2: 'Os seus modelos permanecem ativos e disponíveis para assinantes até que opte por sair.',
      column_models: 'Modelos',
      column_publishing_date: 'Data de publicação',
      column_opt_in_date: 'Data de inscrição na assinatura',
      empty_title: 'Nenhum modelo disponível',
      empty_description: 'Não tem modelos elegíveis para CGTrader Essentials neste momento.',
    },
    join_modal: {
      title: 'Assinaturas CGTrader',
      title_legacy: 'Aderir ao programa Maximize os seus ganhos',
      participating_pill: 'A participar no programa Maximize os seus ganhos',
      intro_heading: 'Ative Maximize os seus ganhos para começar',
      intro_body: 'Desbloqueie oportunidades adicionais de monetização concebidas para aumentar a sua receita a longo prazo. Este programa dá-lhe acesso a:',
      intro_programs_essentials_label: 'CGTrader Essentials e Premium',
      intro_programs_essentials_text: '— Ganhe com os downloads mensais por assinatura',
      intro_programs_enterprise_label: 'Acordos empresariais e personalizados',
      intro_programs_enterprise_text: 'Participe em acordos B2B à medida',
      intro_programs_revenue_label: 'Oportunidades de partilha de receitas',
      intro_programs_revenue_text: 'Beneficie de parcerias estratégicas de distribuição',
      intro_programs_equity_label: 'Colaborações baseadas em participação',
      intro_programs_equity_text: 'Troque modelos selecionados por participação acionária',
      intro_programs_other_label: 'Outros modelos alternativos de compensação',
      intro_programs_other_text: 'à medida que estiverem disponíveis',
      intro_inset_title: 'O que acontece quando adere',
      intro_inset_models: 'Os seus modelos elegíveis passam a integrar o pool do programa',
      intro_inset_earnings: 'Obtém acesso a rendimentos baseados em assinatura',
      intro_inset_opportunities: 'Pode ser considerado para oportunidades empresariais e formas alternativas de compensação',
      section_what_title: 'Como funcionam as assinaturas',
      section_what_body: 'A CGTrader oferece dois níveis de assinatura aos compradores:',
      section_what_tier_essentials_label: 'Essentials',
      section_what_tier_essentials_text: '— $9.99/mês, 25 downloads. Recursos do dia a dia.',
      section_what_tier_premium_label: 'Premium',
      section_what_tier_premium_text: '— $34.99/mês, 25 downloads. Recursos de gama alta.',
      section_what_tiers_note: 'Os seus modelos são incluídos no nível correspondente à sua categoria. Um modelo pode aparecer num ou em ambos os níveis. Os downloads não usados não transitam.',
      section_earnings_title: 'Como são calculados os seus rendimentos',
      section_earnings_body: 'Todos os meses, a CGTrader atribui uma parte da receita de assinatura proporcional ao número de vezes que os seus modelos foram descarregados em relação a todos os downloads por assinatura desse mês.',
      section_earnings_rule: 'Aplica-se uma regra: cada download gera-lhe até ao preço listado do seu modelo multiplicado pela sua taxa de royalties - se o seu modelo tiver o preço de $5, ganha no máximo $5 multiplicado pela sua taxa de royalties por download.',
      section_earnings_timing: 'Os rendimentos são calculados no dia 1 do mês seguinte e nunca são ajustados retroativamente.',
      section_refunds_title: 'Reembolsos e estornos',
      section_refunds_body: 'Se um assinante for reembolsado, esse pagamento é removido do fundo de receita no mês em que o reembolso ocorre, não no mês original do download. Na prática, os reembolsos são raros e não afetarão significativamente os seus rendimentos.',
      section_optin_title: 'Aderir e cancelar',
      section_optin_body: 'Os modelos são adicionados ao catálogo de assinaturas quando Maximize os seus ganhos está ativado (As minhas vendas → Descontos). Para remover os seus modelos, desative a opção. Os rendimentos passados não são afetados.',
      join_cta: 'Aderir a Maximize os seus ganhos',
      description: 'Desbloqueie oportunidades adicionais de monetização projetadas para aumentar as suas receitas a longo prazo. Este programa dá-lhe acesso a:',
      benefit_essentials_label: 'CGTrader Essentials',
      benefit_essentials_text: '– Ganhe com downloads mensais de assinatura',
      benefit_enterprise_label: 'Acordos empresariais e personalizados',
      benefit_enterprise_text: '– Participe em acordos B2B à medida',
      benefit_revenue_label: 'Oportunidades de partilha de receitas',
      benefit_revenue_text: '– Beneficie de parcerias de distribuição estratégicas',
      benefit_equity_label: 'Colaborações baseadas em capital',
      benefit_equity_text: '– Troque modelos selecionados por participação no capital',
      benefit_other_label: 'Outros modelos de compensação alternativa',
      benefit_other_text: 'à medida que estiverem disponíveis',
      info_box_title: 'O que acontece quando adere:',
      info_box_essentials_name: 'CGTrader Essentials',
      info_box_essentials_suffix: 'está totalmente incluído neste programa:',
      info_box_models: 'Os seus modelos elegíveis passam a fazer parte do programa',
      info_box_earnings: 'Obtém acesso a rendimentos baseados em assinatura',
      info_box_enterprise: 'Pode ser considerado para oportunidades empresariais e de compensação alternativa',
      confirm_button: 'Aderir ao programa',
      cancel_button: 'Cancelar',
      got_it_button: 'Entendi',
      success: 'Aderiu com sucesso ao programa Maximize os seus ganhos',
      error: 'Algo correu mal. Por favor, tente novamente.',
    },
  },
  publisher: {
    tooltips: {
      tags:
        'As primeiras 4 a 6 tags são as mais importantes para a pesquisa. Descreva primeiro o objeto principal e depois adicione detalhes.',
      adult_content:
        'Todos os modelos com nudez ou conteúdo violento serão revisados pela CGTrader antes da publicação, em até 1–3 dias úteis. A CGTrader usa os padrões RSAC para avaliar o conteúdo. Conteúdo de nível 0 fica disponível para todos. Modelos classificados como nível 1-2 podem ser publicados com restrição de idade. Modelos classificados como nível 3-4 não são aprovados para publicação no marketplace.',
    },
  },
  skills:{
    '3d-modeling': '3D Modeling',
    '3d-print-modeling': '3D Print Modeling',
    '3d-scanning': '3D Scanning',
    'animating': 'Animating',
    'grooming': 'Grooming',
    'lighting': 'Lighting',
    'low-poly-modeling': 'Low-poly Modeling',
    'particles': 'Particles',
    'pbr-modeling': 'PBR Modeling',
    'post-production': 'Post Production',
    'rendering': 'Rendering',
    'rigging': 'Rigging',
    'shaders': 'Shaders',
    'skinning': 'Skinning',
    'texturing': 'Texturing',
    'uv-mapping': 'UV mapping'
  },
  profilePage: {
    listings: 'Modelos 3D',
    reviews: 'Avaliações',
    imageGallery: 'Galeria de imagens',
    tutorials: 'Tutoriais',
    rating: 'Avaliação',
    reputation: 'Reputação',
    responseRate: 'Taxa de resposta',
    responseTime: 'Tempo de resposta',
    projectsDone: 'Projetos 3D concluídos',
    modelViews: 'Visualizações do modelo',
    modelLikes: 'Curtidas do modelo',
    followers: 'Seguidores',
    software: 'Softwares 3D',
    skill: 'Habilidades',
    about: 'Sobre',
    modelos: 'Modelos 3D',
    projects: 'Projetos 3D',
    reviewsGiven: 'Avaliações feitas',
    ratings: 'Avaliações',
    positive: 'Positivo',
    negative: 'Negativo',
    priceLabel: 'Preço',
    positiveFirst: 'Positivos primeiro',
    negativeFirst: 'Negativos primeiro',
    tooltipTextResponseRate: 'Percentual de mensagens recebidas que o usuário respondeu',
    tooltipTextResponseTime: 'Tempo médio que o usuário leva para responder mensagens',
    tooltipTextProjectsDone: 'Quantidade de projetos 3D concluídos com sucesso. Atualmente trabalhando em {{projectCount}} projetos 3D',
    tooltipTextModelViews: 'Número de vezes que os modelos do designer foram visualizados',
    tooltipTextModelLikes: 'Número de curtidas que os modelos do designer receberam',
    tooltipTextFollowers: 'Quantidade de seguidores que o designer tem',
    noModelsUploaded: 'O usuário ainda não enviou nenhum modelo 3D.',
    noModelsReviews: 'Nenhuma avaliação de modelo 3D ainda.',
    noProjectsReviews: 'Ainda não há avaliações de projetos 3D.',
    loadMore: 'Carregar mais',
    noArtworksUploaded: 'O usuário ainda não enviou nenhuma obra de arte.',
    noTutorialsUploaded: 'O usuário ainda não publicou nenhum tutorial.',
    seeAllModels: 'Ver todos os {{modelCount}} modelos 3D',
    viewAllModels: 'Ver todos os {{modelCount}} modelos'
  },
  navigation: {
    'aria': {
      'open_menu': 'Abrir menu',
      'close_menu': 'Fechar menu',
      'search': 'Buscar',
      'search_by_image': 'Buscar por imagem',
      'cart': 'Carrinho',
      'messages': 'Mensagens',
      'notifications': 'Notificações',
      'account': 'Conta',
      'logo': 'CGTrader - Modelos 3D / Designers 3D',
    },
    navbar: {
      'actions': {
        'new': 'Novos',
        'trending': 'Em alta',
        'top_selling': 'Mais vendidos',
      },
      'budgets': {
        'below_10': 'Abaixo de $10',
        'up_to_10': 'Até $10',
        'more_than_20': 'Mais de $20',
        'more_than_50': 'Mais de $50',
        'free': 'Grátis',
        'sale': 'Em Oferta',
      },
      '3d_models': {
        'categories': 'Categorias',
        'types': 'Tipo',
        'budget': 'Orçamento',
        'all_models': 'Todos os modelos',
        'browse_all': 'Todos os modelos 3D',
        'browse_all_print': 'Todos os modelos para impressão 3D',
        'about': 'Sobre os modelos 3D',
        'about_print': 'Sobre a impressão 3D',
      },
      'community': {
        'title': 'Comunidade',
        'earn': 'Ganhe',
        'upload_3d_model': 'Enviar modelo 3D',
        'search_for_projects': 'Buscar projetos',
      },
      'grow_your_sales': {
        'title': 'Aumente suas Vendas',
        'sell_more': 'Venda Mais 🚀',
        '3d_market_insights': 'Insights do Mercado 3D',
        'top_model_searches': 'Pesquisas Populares de Modelos 3D',
        'top_print_searches': 'Pesquisas Populares de Impressão 3D',
      },
    },
    'search': {
      placeholder: 'Pesquisar em mais de 2 milhões de modelos',
    },
    'user': {
      login: 'Entrar',
      register: 'Registre-se',
    },
    'projects': {
      seller_perspective: 'Projetos 3D Freelance',
      browse: 'Procurar Projetos',
      start: 'Iniciar Um Projeto',
      about: 'Sobre Projetos 3D',
      work: 'Trabalho Com Cgtrader',
      my_projects: 'Meus projetos',
      buyer_perspective: 'Contratar designers 3D',
    },
    '3d-models': {
      'title': 'Modelos 3D',
      '3d-printing': 'Impressao 3D',
      'pbr': 'PBR',
      'vr_low-poly': 'VR / Baixa-poli',
      'scanned_3d-models': 'Modelos digitalizados 3D',
      'find_designers': 'Encontrar melhores designers',
      'discounts': 'Descontos',
      'scripts_apps': 'Scripts e Aplicativos',
      'textures': 'Texturas',
      'show-all': 'Mostre tudo',
      'free': 'Modelos livre 3D',
    },
    'sell_3d-models': 'Vender Modelos 3D',
    'enterprise': {
      title: 'Produção de Conteúdo 3D',
      management: 'Gerenciamento de ativos 3D',
    },
    'credits_guest_widget': {
      'get': ' e chegar até a ',
      'create': 'Crie uma conta agora!',
      'learn_more': 'Saiba mais sobre créditos Fidelidade CGTrader ',
      'link': 'aqui',
      'text_below_1': 'Os créditos podem ser usados ​​na compra "',
      'text_below_2':
        '"Assinar modelos marcados e cobrir até 30% de desconto do preço.',
      'sign-up': 'inscrever-se',
      'discount': ' desconto',
      'for': ' Para o seu ',
      'purchase': 'primeira compra!',
    },
    'tooltips': {
      discounts: 'CGTrader desconto de fidelidade',
      cart: 'Carrinho de compras',
      conversations: 'Minhas conversas',
      notifications: 'Notificações',
      publisher: 'Editor',
    },
    'cart_widget': {
      'wishlist_tab': 'Lista de desejos',
      'recently_viewed_tab': 'Vistos recentemente',
      'potential_discount': 'Desconto potencial:',
      'discount_applied': 'Descontos aplicados:',
      'sale_tooltip': 'Os descontos das nossas campanhas de promoção só são aplicados quando o seu carrinho atinge ${{threshold}} ou mais.',
      'left_to_unlock_discounts': 'Faltam {{leftToUnlock}} para desbloquear descontos',
      'continue_shopping': 'Continuar comprando',
      'wishlist_empty_title': 'Sua lista de desejos está vazia',
      'wishlist_empty_text': 'Comece a explorar e salve seus favoritos para mais tarde — eles aparecerão aqui.',
      'recently_viewed_empty_title': 'Nada aqui ainda',
      'recently_viewed_empty_text': 'Comece a explorar e seus itens vistos recentemente aparecerão aqui.',
      'sale_tooltip_text': 'Este item está em promoção, mas o desconto só será aplicado quando o subtotal do seu carrinho atingir ${{threshold}} ou mais.',
      title: 'Carrinho',
      subtitle: 'O Carrinho está Vazio',
      text: 'Comece a explorar e encha seu carrinho com descobertas incríveis!',
      have: 'Você tem ',
      items: ' itens no seu carrinho de compras.',
      total: 'Total: ',
      remainer: 'Para ativar os pontos de CGTrader, adicione: ',
      used: 'Créditos utilizados: ',
      discount: 'Desconto com cupom empresa: ',
      sale_discounts: 'Descontos aplicados: ',
      sale_time_left: 'Tempo restante para a venda',
      final: 'Preço final: ',
      proceed: 'Fazer o check-out',
      view: ' Ver carrinho',
    },
    'community': {
      'title': 'Comunidade',
      'galleries': 'Galerias',
      'tutorials': 'Tutoriais',
      'forum': 'Fórum',
      'designers': 'Designers',
      'challenges': 'Desafios',
      'digital_art': 'Concurso de Arte Digital',
      'blog': 'Blog',
      'community_ratings': 'Classificações da comunidade',
      'sell_3d-models': 'Vender modelos 3D',
      'printlist': '3D imprimeLista',
      'invite': 'Convidar um amigo',
    },
    'credits_user_widget': {
      title: 'CGTrader desconto de fidelidade',
      par_1: 'Você tem ',
      par_2: ' créditos CGTrader.',
      par_2_variation:
        ' em pontos que você pode gastar quando nenhuma promoção estiver disponível.',
      notice:
        'AVISO: Os pontos CGTrader não podem ser usados durante a venda em andamento, mas estarão disponíveis novamente assim que a venda terminar. Enquanto isso, confira ótimas ofertas em modelos 3D <a href="https://www.cgtrader.com/3d-models?sale_off=1">aqui</a>',
      first_text_1:
        'Considere isso como um presente para sua primeira compra - você pode usar créditos ao comprar "',
      first_text_2:
        ' "Os modelos marcados e obter até 30% de desconto de seu preço. Credits só podem ser utilizados se o valor total de seu carrinho for igual ou superior a US',
      regular_text_1: 'Os créditos podem ser usados ​​na compra "',
      regular_text_2:
        ' "Assinar modelos marcados e cobrir até 30% de desconto de seu preço.',
      important: 'IMPORTANTE:',
      message:
        ' Os créditos não podem ser usados ​​durante as campanhas venda, mas você ainda pode aumentar seu nível de royalties e recolher mais créditos para a sua próxima compra.',
      more_credits: 'Como faço para obter mais créditos?',
      list_item:
        'Ao aumentar seus gastos vida na CGTrader, o seu crédito ganhar aumentos da taxa também.',
      learn_more: 'Saber mais',
      earn_rate: 'Crédito ganhar taxa ',
      lifetime_spending: 'Gastos Lifetime: ',
      next_level: 'Próximo nível: ',
      condition_1:
        'Os pontos CGTrader podem ser aplicados na compra de modelos marcados com o símbolo <i class="custom-font-icon custom-font-icon--small icon-wallet"></i>, proporcionando até 30% de desconto no preço.',
      condition_2:
        'Os pontos só podem ser usados se o valor total do seu carrinho for de <strong>${{minimum}}</strong> ou mais.',
      condition_3:
        'Durante promoções ou vendas ativas, os pontos não podem ser usados.',
      condition_4:
        'Lembre-se de que os pontos têm uma data de validade - seus pontos expirarão em <strong>{{days}}</strong> dias.',
    },
    'item_add_message': 'Com sucesso, foi adicionado ao carrinho',
    'already_added_message': 'Já foi adicionado ao carrinho',
    'conversations_widget': {
      messages: {
        loading: 'Carregando caixa de entrada',
      },
      conversations: 'conversações',
      types: {
        personal: 'Mensagem pessoal',
        offer: 'Oferta de preço',
        cgtrader_support: 'Suporte CGTrader',
        model_support: 'Suporte modelo',
        job_application: 'Projeto 3D',
        file_conversion_request: 'pedido de conversão de arquivos',
        model_feedback: 'Product feedback',
        promotions: 'promoções',
      },
    },
    'user_menu': {
      gdpr_notice: {
        message: 'Você precisa revisar suas {{link}}',
        link: 'preferências de notificação por e-mail',
      },
      dashboard: 'Admin dashboard',
      settings: 'Configurações da Conta',
      public_profile: 'Perfil público',
      logout: 'Sair',
      seller: {
        publishing: 'Enviar Modelo 3D',
        models: 'Meus modelos',
        sales: 'Minhas vendas',
        subscription: 'Assinatura',
        analytics: 'Analítica',
        freelance: 'Meus Projetos 3D',
        wishlist: 'Modelo 3D Lista de Desejos',
        freelance_cgtrader: 'Freelance com CGTrader',
        publish_project: 'Publicar um projeto',
        find_new_projects: 'Encontrar novos projetos 3D',
      },
      buyer: {
        purchases: 'Minhas compras',
        wishlist: 'Modelo 3D Lista de Desejos',
        freelancers: 'Encontrar Freelancers',
        sell: 'Vender modelos 3D',
      },
    },
    'already_purchased_message': 'Você já comprou este item.',
    'cart_limit_reached':
      'Você atingiu o limite de 500 itens no seu carrinho. Para continuar comprando, por favor, complete seu pedido atual e inicie um novo para qualquer item adicional.',
  },
  'sale_off_bar': {
    'find_deals': 'Encontre ofertas',
  },
  'subscribe_bar': {
    'content_full': '25 modelos por mês, a partir de {{price}}',
    'content_short': '25 modelos por mês, a partir de {{price}}',
    'cta': 'Assinar',
  },
  'cgdream_notice_bar': {
    'message': 'Vindo do CGDream? A geração de imagens agora está aqui, no CGTrader AI.',
    'dismiss': 'Fechar aviso',
  },
  footer: {
    'subscribe': {
      'header': 'Assine a nossa notícia:',
      'button-active': 'Se inscrever',
      'button-disabled': 'Subscrito',
      'text': 'Ao subscrever você confirma que leu e aceitou o nosso',
      'terms-link': 'Termos de uso',
      'placeholder': 'Digite seu e-mail',
    },
    'links': {
      companyLinks: [
        {
          text: 'Empresa',
          link: '/discover/about-us',
        },
        {
          text: 'Blogue',
          link: '/blog',
        },
        {
          text: 'Carreiras',
          link: '/pages/careers',
        },
        {
          text: 'Centro de ajuda',
          link: 'https://help.cgtrader.com',
        },
      ],
      buyLinks: [
        {
          text: 'Comprar modelos 3D',
          link: '/pt/3d-modelos',
        },
        {
          text: 'Para empresas',
          link: '/discover/business-account',
        },
        {
          text: 'Conjuntos de dados 3D',
          link: '/discover/datasets',
        },
        {
          text: 'Contratar designer 3D',
          link: '/3d-modeling-jobs',
        },
        {
          text: 'Modelos 3D gratuitos',
          link: '/pt/livre-3d-modelos',
        },
        {
          text: 'Modelos 3D para impressão gratuitos',
          link: '/pt/livre-3d-impressao-modelos',
        },
      ],
      sellLinks: [
        {
          text: 'Vender modelos 3D',
          link: '/discover/sell-3d-models',
        },
        {
          text: 'Aumente suas vendas',
          link: '/discover/sell-more',
        },
        {
          text: 'Insights do mercado 3D',
          link: '/discover/3d-market-trends',
        },
        {
          text: 'Principais pesquisas de modelos 3D',
          link: '/discover/3d-models-top-searches',
        },
        {
          text: 'Principais pesquisas de impressão 3D',
          link: '/discover/3d-print-models-top-searches',
        },
      ],
      communityLinks: [
        {
          text: 'Comunidade',
          link: '',
        },
        {
          text: 'Melhores designers',
          link: '/designers',
        },
        {
          text: 'Desafios',
          link: '/challenges',
        },
        {
          text: 'Fórum',
          link: '/forum',
        },
      ],
      // enterpriseLinks: [
      //   {
      //     text: 'Modelry',
      //     link: 'https://www.modelry.ai/?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=modelry&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: 'Visualizador 3D',
      //     link: 'https://www.modelry.ai/3d-viewer?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_viewer&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D visualização do produto',
      //     link: 'https://www.modelry.ai/3d-product-visualization?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_product_visualization&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: 'Digital Asset Management 3D',
      //     link: 'https://www.modelry.ai/3d-digital-asset-management?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_digital_asset_management&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: 'Personalizado Modelagem 3D',
      //     link: 'https://www.modelry.ai/how-to-order-custom-3d-models?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_content_production&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: 'Fotografia virtual',
      //     link: 'https://www.modelry.ai/virtual-photography?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=virtual_photography&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      // ],
      // aiImageGeneratorLinks: [
      //   {
      //     text: 'CGDream | Gerador de Imagens com IA',
      //     link: 'https://cgdream.ai/',
      //   },
      //   {
      //     text: 'Gerar Imagens com Flux Dev',
      //     link: 'https://cgdream.ai/features/free-flux-ai-image-generator',
      //   },
      //   {
      //     text: 'IA de Texto para Imagem',
      //     link: 'https://cgdream.ai/features/text-to-image-ai-generator',
      //   },
      //   {
      //     text: 'Editor de Fotos com IA',
      //     link: 'https://cgdream.ai/features/ai-photo-editor',
      //   },
      //   {
      //     text: 'Renderização 3D com IA',
      //     link: 'https://cgdream.ai/features/ai-3d-rendering',
      //   },
      //   {
      //     text: 'Gerador de Modelos 3D com IA',
      //     link: 'https://cgdream.ai/features/ai-3d-model-generator-image-to-3d',
      //   },
      //   {
      //     text: 'Filtros de IA para Imagens',
      //     link: 'https://cgdream.ai/features/ai-filters-for-images',
      //   },
      //   {
      //     text: 'Ampliador de Imagens com IA',
      //     link: 'https://cgdream.ai/features/ai-image-upscaler',
      //   },
      //   {
      //     text: 'Preenchimento de Imagens com IA',
      //     link: 'https://cgdream.ai/features/ai-image-inpainting',
      //   },
      // ],
    },
    'bottom-row': {
      'terms-link': 'Termos e Condições',
      'privacy': 'Privacidade',
    },
  },
  profile: {
    model_uploader: {
      file_not_finalized_tooltip: 'Este ficheiro não terminou de carregar e não será publicado. Remova-o e carregue-o novamente.',
      file_not_finalized_sr: 'O ficheiro não terminou de carregar e não será publicado.',
    },
    my_models: {
      pack_creation: {
        flash_error: 'Algo correu mal, tente novamente',
        load_error: 'Não foi possível carregar os modelos selecionados. Isto pode acontecer quando são selecionados demasiados modelos de uma vez. Tente novamente ou selecione menos modelos.',
        retry: 'Tentar novamente',
      },
      image_restore: {
        body_default: 'Algumas pré-visualizações dos seus modelos podem ter sido afetadas por um problema de armazenamento recente. Se alguma das suas imagens parecer danificada, clique em Restaurar imagens e iremos verificá-las e corrigi-las em todos os seus modelos.',
        title_pending: 'Estamos a restaurar as suas pré-visualizações',
        body_pending: 'O seu pedido foi registado: estamos a verificar cada modelo. Este processo é executado em segundo plano e pode demorar até 3 dias, por isso não precisa de manter esta página aberta. Iremos avisá-lo aqui e por e-mail quando terminar.',
        title_finished: 'Restauração concluída',
        body_finished: 'Verificámos todos os seus modelos e restaurámos o que foi possível. Se uma miniatura ainda mostrar "Sem pré-visualização", essa imagem não pôde ser recuperada; pode carregá-la novamente.',
        button_restore: 'Restaurar imagens',
        button_requested: 'Restauração solicitada',
        helper_within_3_days: 'As pré-visualizações são atualizadas no prazo de 3 dias.',
      },
      errors: {
        load_failed: 'Não foi possível carregar os seus modelos. Atualize a página e tente novamente.',
      },
    },
    my_sales: {
      earnings_detail: {
        generate_report: 'Gerar relatório',
        report_sent_confirmation: 'O relatório será enviado para o seu e-mail em breve!',
        errors: {
          sales_load_failed: 'Não foi possível carregar os ganhos de vendas.',
          downloads_load_failed: 'Não foi possível carregar os ganhos de downloads.',
          subscription_earnings_load_failed: 'Não foi possível carregar os ganhos de assinatura.',
        },
      },
      leave_program_modal: {
        header: 'Sair do programa Maximize seus ganhos',
        primary_action: 'Sair do programa Maximize seus ganhos',
        cancel: 'Cancelar',
        description: 'Tem certeza de que deseja parar de participar do programa Maximize seus ganhos?',
        bullet_models: 'Todos os seus modelos deixarão de participar dos ganhos por Assinatura',
        bullet_promotion: 'Você não será incluído em acordos empresariais, de compartilhamento de receita, participação ou compensação alternativa',
        bullet_revenue: 'Você continuará ganhando com as vendas padrão do marketplace como de costume',
        warning_title: 'Importante: Lógica de ganhos mensais',
        warning_active_deals: 'A participação é registrada às 00:00 do 1º dia de cada mês',
        warning_pending_payouts: 'Se você sair durante o mês, os ganhos do mês atual não serão afetados',
        warning_re_enroll: 'As alterações entram em vigor a partir do próximo ciclo mensal',
        warning_historical_data: 'Os pools de receita são calculados mensalmente com base nos downloads reais durante aquele mês',
        info_line: 'Seus ganhos do mês atual estão seguros e serão pagos de acordo com o cronograma padrão de pagamento.',
      },
    },
  },
  items: {
    last_card: {
      text: 'Não foi possível encontrar o que você está procurando?',
      button_text: 'Pedir um modelo personalizado 3D',
    },
  },
  model: {
    download_limit_exceeded: 'Você excedeu seu limite diário de downloads. Por favor, tente novamente amanhã. Esse limite não se aplica a usuários que fizeram uma compra nos últimos 12 meses.',
    subscription: {
      limit_reached_detailed: 'Você atingiu seu limite de {{limit}} downloads deste mês. Seu limite é redefinido em {{reset_date}}. Para baixar mais modelos agora, você pode comprá-los individualmente.',
      limit_reached_detailed_no_date: 'Você atingiu seu limite de {{limit}} downloads deste mês. Para baixar mais modelos agora, você pode comprá-los individualmente.',
    },
  },
  search_page: {
    seo_area: {
      by_relevance: 'Por relevância:',
      by_extension: 'Por extensão:',
      by_style: 'Por estilo:',
      by_type: 'Por tipo:',
    },
    results: {
      empty: 'Nenhum modelo corresponde aos seus filtros.',
      error: 'Ocorreu um erro ao carregar os resultados. Tente novamente.',
      pagination: 'Páginas de resultados da pesquisa',
      showing: 'Mostrando {{start}}-{{end}} de {{total}}',
      per_page: 'Por página',
      first_page: 'Ir para a primeira página',
      previous_page: 'Ir para a página anterior',
      next_page: 'Ir para a próxima página',
      last_page: 'Ir para a última página',
      page_input: 'Ir para a página',
      results_count: '{{total}} resultados',
    },
    filters: {
      poly_count: {
        title: 'Contagem de polígonos',
        title_with_count: 'Contagem de polígonos ({{count}})',
        low_poly_label: 'Low-poly',
        low_poly_value: 'até 20k',
        mid_poly_label: 'Mid-poly',
        mid_poly_value: '20k - 100k',
        high_poly_label: 'High-poly',
        high_poly_value: '100k - 1M+',
        reset: 'Redefinir',
        checkboxes_group_label: 'Opções de intervalo de polígonos',
        info_tooltip: 'A contagem de polígonos é o número total de polígonos que compõem um modelo 3D.\n\nLow-poly: até 20k — ideal para uso em tempo real (jogos, mobile, AR/VR).\nMid-poly: 20k – 100k — equilibrado para a maioria dos usos em produção.\nHigh-poly: 100k – 1M+ — ideal para renders, cinema e visualização de produto.',
      },
      style: {
        title: 'Estilo',
        title_with_count: 'Estilo ({{count}})',
        find_placeholder: 'Buscar estilos...',
        no_matches: 'Sem resultados',
        reset: 'Redefinir',
        tags_group_label: 'Opções de estilo',
        show_more: 'Mostrar mais',
        show_less: 'Mostrar menos',
        groups: {
          era: 'Época',
          genre: 'Gênero',
          rendering: 'Renderização',
          look: 'Estética',
          surface: 'Superfície',
          purpose: 'Finalidade',
          form: 'Forma',
          subject: 'Tema',
        },
      },
      features: {
        title: 'Características',
        title_with_count: 'Características ({{count}})',
        search_placeholder: 'Buscar recursos...',
        no_matches: 'Sem resultados',
        reset: 'Redefinir',
        game_ready: 'Pronto para jogos',
        with_renders: 'Com renders',
        simulation_ready: 'Pronto para simulação',
        show_more: 'Mostrar mais',
        show_less: 'Mostrar menos',
      },
      size: {
        title: 'Tamanho',
        unit: 'Unidade',
        units: {
          cm: 'Centímetros (cm)',
          in: 'Polegadas (in)',
          mm: 'Milímetros (mm)',
        },
        whole_print_size: 'Tamanho total de impressão',
        largest_print_size: 'Maior tamanho de impressão',
        width: 'Largura (X)',
        depth: 'Profundidade (Y)',
        height: 'Altura (Z)',
        quick_select: 'Seleção rápida',
        presets: {
          under_5: '< 5 cm',
          range_5_15: '5 - 15 cm',
          range_15_30: '15 - 30 cm',
          range_30_50: '30 - 50 cm',
          range_50_100: '50 - 100 cm',
          over_100: '100 cm +',
        },
        reset: 'Redefinir',
      },
      categories: {
        title: 'Categorias',
      },
      date_published: {
        title: 'Data de publicação',
        all_time: 'Todo o período',
        last_24_hours: 'Últimas 24 horas',
        last_7_days: 'Últimos 7 dias',
        last_month: 'Último mês',
        last_3_months: 'Últimos 3 meses',
        last_6_months: 'Últimos 6 meses',
        last_year: 'Último ano',
        custom: 'Escolher data manualmente',
        start_date: 'Data de início',
        end_date: 'Data de término',
        previous_month: 'Mês anterior',
        next_month: 'Mês seguinte',
        cancel: 'Cancelar',
        apply: 'Aplicar',
      },
      designers: {
        title: 'Designer',
        search_placeholder: 'Encontrar designer...',
        following: 'Designers que você segue',
        following_indicator: 'Seguindo',
        top: 'Melhores designers',
        models_count: '({{count}} modelos)',
        loading: 'Carregando designers...',
        searching: 'Procurando designers...',
        no_results: 'Nenhum designer encontrado.',
        no_following: 'Você ainda não segue nenhum designer',
        show_more: 'Mostrar mais',
      },
      advanced: {
        title: 'Filtros avançados',
        group_label: 'AVANÇADO',
        personal_group_label: 'PESSOAL',
        purchases_group_label: 'COMPRAS',
        packs: 'Pacotes',
        has_marmoset: 'Com visualizador 3D',
        has_video: 'Com vídeo',
        cgt_standard: 'CGT Standard',
        wish_list_only: 'Apenas lista de desejos',
        liked_models_only: 'Apenas modelos curtidos',
        exclude_purchased_items: 'Excluir itens comprados',
        purchased_items_only: 'Apenas itens comprados',
      },
      file_format: {
        title: 'Formato de arquivo',
        search_placeholder: 'Digite para pesquisar...',
        show_more: 'Mostrar mais',
        show_less: 'Mostrar menos',
      },
      price: {
        title: 'Preço',
        on_sale: 'Itens com desconto',
        with_subscription: 'Itens de assinatura',
        min_price: 'Preço mín.',
        max_price: 'Preço máx.',
        ranges: {
          free: 'Grátis',
          range_2_10: '$2 - $10',
          range_10_20: '$10 - $20',
          range_20_50: '$20 - $50',
          range_50_100: '$50 - $100',
          more_than_100: '$100+',
        },
      },
      license: {
        title: 'Licenças',
        group_label: 'LICENÇAS',
        ai_usage_group_label: 'USO DE IA',
        all: 'Todas as licenças',
        royalty_free: 'Livre de royalties',
        editorial: 'Uso editorial',
        custom: 'Personalizada',
        ai_usage_allowed: 'Uso de IA permitido',
      },
      quality: {
        title: 'Qualidade',
        content_source_title: 'Fonte de conteúdo',
        tooltip: 'Basic – recursos de nível básico com geometria e materiais mais simples.\nPremium – recursos de maior fidelidade com topologia limpa e materiais detalhados.\nPro – recursos de primeira linha criados segundo padrões profissionais e de produção.\n\nGerado por IA – mostrar apenas recursos criados com ferramentas de IA.\nCriado por humanos – mostrar apenas recursos criados por designers humanos.',
        levels: {
          any: 'Qualquer',
          basic: 'Basic',
          premium: 'Premium',
          pro: 'Pro',
        },
        content_source: {
          all: 'Todo o conteúdo',
          ai_generated: 'Gerado por IA',
          human_created: 'Criado por humanos',
        },
      },
      more_filters: {
        trigger_label: 'Filtros',
        trigger_label_with_count: 'Filtros ({{count}})',
        desktop_title: 'Mais filtros',
        modal_title: 'Todos os filtros',
        close_label: 'Fechar filtros',
        reset: 'Redefinir',
        apply_filters: 'Aplicar filtros',
      },
      asset_type: {
        group_label: 'Tipo de recurso',
        all: 'Tudo',
        three_d_only: 'Apenas 3D',
        three_d_only_short: '3D',
        three_d_print_only: 'Apenas impressão 3D',
        three_d_print_only_short: 'Impressão 3D',
      },
      clear_all: 'Limpar todos os filtros',
      sorting: {
        title: 'Ordenar',
        trending: 'Em alta',
        top_sellers: 'Mais vendidos',
        reset: 'Redefinir',
        best_match: 'Melhor correspondência',
        default_option: 'Padrão',
        newest: 'Mais recentes',
        oldest: 'Mais antigos',
        lower_price: 'Menor preço',
        higher_price: 'Maior preço',
      },
      secondary: {
        group_label: 'Filtros secundários',
        search_placeholder: 'Buscar nos resultados...',
      },
      technical_attributes: {
        group_label: 'Atributos técnicos',
        animated: 'Animado',
        rigged: 'Com rig',
        low_poly: 'Low-poly',
        pbr: 'PBR',
        simulation_ready: 'Pronto para simulação',
      },
      print_attributes: {
        group_label: 'Atributos de impressão',
        with_makes: 'Com Makes',
        three_d_print_verified: 'Impressão 3D verificada',
        simulation_ready: 'Pronto para simulação',
      },
      tags: {
        title: 'Sugestões de tags',
        more: 'Mais',
        title_with_count: 'Sugestões de tags ({{count}})',
        tags_group_label: 'Sugestões de tags',
        find_placeholder: 'Buscar categorias...',
        no_matches: 'Sem resultados',
        show_more: 'Mostrar mais',
        show_less: 'Mostrar menos',
        reset: 'Redefinir',
      },
    },
  },
}
// jshint ignore: end
